import type { UserCompany } from '@/features/auth/types/auth.types';

const COMPANIES_KEY = 'hb_companies';
const LAST_COMPANY_PREFIX = 'hb_last_company:';

function lastCompanyKey(email: string): string {
  return `${LAST_COMPANY_PREFIX}${email.trim().toLowerCase()}`;
}

export const companyStorage = {
  setCompanies(companies: UserCompany[]) {
    localStorage.setItem(COMPANIES_KEY, JSON.stringify(companies));
  },
  getCompanies(): UserCompany[] {
    const raw = localStorage.getItem(COMPANIES_KEY);
    if (!raw) return [];
    try {
      const parsed: unknown = JSON.parse(raw);
      return Array.isArray(parsed) ? (parsed as UserCompany[]) : [];
    } catch {
      return [];
    }
  },
  clearCompanies() {
    localStorage.removeItem(COMPANIES_KEY);
  },
  setLastCompany(email: string, customerUuid: string) {
    if (!email) return;
    localStorage.setItem(lastCompanyKey(email), customerUuid);
  },
  getLastCompany(email: string): string | null {
    if (!email) return null;
    return localStorage.getItem(lastCompanyKey(email));
  },
};
